import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';

export default function OfflineIndicator() {
  const isCurrentlyOffline = !navigator.onLine;
  const [offline, setOffline] = useState(isCurrentlyOffline);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setOffline(false);
      setIsDismissed(false);
    };
    const handleOffline = () => setOffline(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!offline || isDismissed) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -100, opacity: 0 }}
        transition={{ type: 'spring' as const, stiffness: 260, damping: 20 }}
        className="fixed inset-x-0 top-0 z-50 md:inset-x-auto md:bottom-4 md:right-4 md:top-auto md:max-w-sm"
        onClick={() => setIsDismissed(true)}
      >
        <div className="px-1 pt-1 md:px-0 md:pt-0">
          <div
            className="flex cursor-pointer items-center space-x-3 rounded-lg bg-gradient-to-r from-red-500/90 to-rose-600/90 p-3 shadow-lg ring-1 ring-red-500/20 transition-colors hover:from-red-500/95 hover:to-rose-600/95"
            role="button"
            aria-label="Dismiss offline notification"
          >
            <div className="shrink-0">
              <div className="flex size-8 items-center justify-center rounded-full bg-red-600">
                <svg
                  className="size-4 animate-pulse text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                  />
                </svg>
              </div>
            </div>
            <div className="min-w-0 flex-1">
              <p className="truncate font-medium text-white">
                No Internet Connection
              </p>
              <p className="mt-1 truncate text-sm text-red-100">
                Click to dismiss
              </p>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
